<div style="display: flex; flex-direction: column; align-items: start" class="m-4">
	<div *ngIf="filters.length">
		<kendo-filter #filter [filters]="filters" [value]="value" (valueChange)="onFilterChange($event)">
			<ng-container *ngFor="let filter of filters">
				<kendo-filter-field [field]="filter.field" [editor]="filter.editor" [operators]="filter.operators || ['neq', 'eq', 'contains']">
					<ng-template kendoFilterValueEditorTemplate let-currentItem>
						<ng-container *ngIf="(filter.fieldControlType === 'TEXTBOX' || filter.fieldControlType == 'FILEUPLOAD') && filter.editor === 'string'">
							<kendo-textbox [(ngModel)]="currentItem.value" (input)="
                                    editorValueChange(
                                        $event.target.value,
                                        currentItem,
                                        filter.value
                                    )
                                " style="
                                    width: 100%;
                                    height: auto;
                                    border-radius: 5px;
                                " />
						</ng-container>
						<ng-container *ngIf="filter.fieldControlType === 'DROPDOWNLIST' && filter.editor === 'string'">
							<kendo-dropdownlist [data]="dropDownData[filter.fieldCode]" textField="text" valueField="value" [valuePrimitive]="true" [(ngModel)]="currentItem.value" (valueChange)="
                                    editorValueChange(
                                        $event,
                                        currentItem,
                                        filter.value
                                    )
                                "></kendo-dropdownlist>
						</ng-container>
						<ng-container *ngIf="filter.editor === 'date'">
							<kendo-datepicker (valueChange)="editorValueChange($event, currentItem, filter.value)"></kendo-datepicker>
						</ng-container>
						<ng-container *ngIf="filter.editor === 'string' && filter.fieldControlType === 'COLORPICKER'">
							<kendo-colorpicker [value]="selected" (valueChange)="onChange($event)"></kendo-colorpicker>
						</ng-container>
						<ng-container *ngIf="filter.editor === 'number' && filter.fieldControlType === 'TEXTBOX'">
							<kendo-numerictextbox [value]="currentItem.value" (input)="
							editorValueChange(
								$event.target.value,
								currentItem,
								filter.value
							)
						"/>
						</ng-container>
						<ng-container *ngIf="filter.editor === 'number' && filter.fieldControlType === 'SLIDER'">
							<kendo-slider #value [fixedTickWidth]="5" [min]="0" [max]="100" [smallStep]="smallStep" [(ngModel)]="valueHorizontal" (input)="
                                editorValueChange(
                                    $event.target.value,
                                    currentItem,
                                    filter.value
                                )
                            ">
								<kendo-slider-messages increment="Right" decrement="Left"></kendo-slider-messages>
							</kendo-slider>
							<div>{{ valueHorizontal }}</div>
						</ng-container>
						<ng-container *ngIf="filter.editor === 'number' && filter.fieldControlType === 'RATING'">
							<kendo-rating name="rating" [(ngModel)]="currentItem.value" (input)="
                    editorValueChange(
                        $event.target.value,
                        currentItem,
                        filter.value
                    )
                "></kendo-rating>
						</ng-container>
						<ng-container *ngIf="filter.editor === 'string' && filter.fieldControlType === 'MASKED'">
							<kendo-maskedtextbox mask="(999) 000-00-00-00" [value]="value"  (input)="
							editorValueChange(
								$event.target.value,
								currentItem,
								filter.value
							)
						"></kendo-maskedtextbox>
						</ng-container>
					</ng-template>
				</kendo-filter-field>
			</ng-container>
		</kendo-filter>
	</div>
	<div style="margin-top: 2em">
		<button kendoButton type="button" (click)="applyFilters()"> Usa Filtri </button>
	</div>
</div>